import styled from 'styled-components';

import { ChangePasswordForm } from 'components/organisms/ChangePasswordForm';
import { Screen } from 'components/templates/Screen';

function ChangePasswordPage() {
  return (
    <Wrapper>
      <Content>
        <FormWrapper>
          <ChangePasswordForm />
        </FormWrapper>
      </Content>
    </Wrapper>
  );
}

export default ChangePasswordPage;

const Wrapper = styled(Screen)`
  width: 100vw;
  height: 100vh;
  padding: 51px 24px 56px;
  color: var(--blue-100);
  background-color: var(--white);
  overflow: auto;
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
